// Synthesizes a short thunder "bang" with the Web Audio API (no asset needed).
export function playThunder() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const now = ctx.currentTime;
    const dur = 1.7;

    // Rumbling filtered noise
    const buf = ctx.createBuffer(1, Math.floor(ctx.sampleRate * dur), ctx.sampleRate);
    const data = buf.getChannelData(0);
    for (let i = 0; i < data.length; i++) {
      const t = i / data.length;
      data[i] = (Math.random() * 2 - 1) * Math.pow(1 - t, 1.7);
    }
    const noise = ctx.createBufferSource();
    noise.buffer = buf;
    const lp = ctx.createBiquadFilter();
    lp.type = "lowpass";
    lp.frequency.setValueAtTime(600, now);
    lp.frequency.exponentialRampToValueAtTime(70, now + dur);
    const ng = ctx.createGain();
    ng.gain.setValueAtTime(0.0001, now);
    ng.gain.exponentialRampToValueAtTime(0.95, now + 0.04);
    ng.gain.exponentialRampToValueAtTime(0.0001, now + dur);
    noise.connect(lp);
    lp.connect(ng);
    ng.connect(ctx.destination);

    // Deep boom
    const osc = ctx.createOscillator();
    osc.type = "sine";
    osc.frequency.setValueAtTime(130, now);
    osc.frequency.exponentialRampToValueAtTime(32, now + dur);
    const og = ctx.createGain();
    og.gain.setValueAtTime(0.0001, now);
    og.gain.exponentialRampToValueAtTime(0.7, now + 0.05);
    og.gain.exponentialRampToValueAtTime(0.0001, now + dur);
    osc.connect(og);
    og.connect(ctx.destination);

    noise.start(now);
    osc.start(now);
    noise.stop(now + dur);
    osc.stop(now + dur);
    setTimeout(() => ctx.close(), (dur + 0.25) * 1000);
  } catch (e) {
    /* silent */
  }
}
